import { LineOverview } from '@/components/modules/line/overview';
import { OceanServiceSchedules } from '@/components/modules/ocean-service/schedules';
import { OptionHeader } from '@/components/modules/option/header';
import { MODE_WATER } from '@/lib/constants';
import { OptionModel } from '@/lib/models/option/types';

export interface OceanServiceSummaryProps {
  option: OptionModel;
  originId: string;
  destinationId: string;
}

const OceanServiceSummary = ({ option, originId, destinationId }: OceanServiceSummaryProps) => {
  const mode = MODE_WATER;
  return (
    <>
      <OptionHeader option={option} mode={mode} originId={originId} destinationId={destinationId} />
      <OceanServiceSchedules option={option} mode={mode} originId={originId} destinationId={destinationId} />
      <LineOverview option={option} />
    </>
  );
};

export { OceanServiceSummary };
